import { IAxiosClient } from 'infrastructure/axiosClient/IAxiosClient';
import { ApiPathConfig } from '../types';
import { AxiosResponse } from 'axios';

export async function callApi<TRequest, TResponse>(
  config: ApiPathConfig<TRequest, TResponse>,
  axiosClient: IAxiosClient,
  dto: TRequest
): Promise<TResponse>;

export async function callApi<TRequest>(
  config: ApiPathConfig<TRequest, void>,
  axiosClient: IAxiosClient,
  dto: TRequest
): Promise<void>;

export async function callApi<TResponse>(
  config: ApiPathConfig<void, TResponse>,
  axiosClient: IAxiosClient,
  dto: void
): Promise<TResponse>;

export async function callApi(
  config: ApiPathConfig<void, void>,
  axiosClient: IAxiosClient,
  dto: void
): Promise<void>;

export async function callApi<TRequest, TResponse>(
  config: ApiPathConfig<TRequest, TResponse>,
  axiosClient: IAxiosClient,
  dto: TRequest
): Promise<TResponse | void> {
  let path: string = config.path;
  let httpPromise: Promise<AxiosResponse>;

  if (config.method === 'GET') {
    if (config.buildRoute) {
      path = config.buildRoute(dto);
    }

    httpPromise = axiosClient.get(path);
  } else {
    httpPromise = axiosClient.post(path, dto);
  }

  const response: AxiosResponse = await httpPromise;

  const data: unknown = extractResponseData(response);

  if (config.responseValidator) {
    return validateResponsePayload<TResponse>(config.responseValidator, data);
  }

  return response.data as TResponse;
}

function extractResponseData(response: AxiosResponse): unknown {
  const responseData = response.data;

  if (isNestedDataResponse(responseData)) {
    return responseData.data;
  }

  return responseData;
}

function isNestedDataResponse(data: unknown): data is { data: unknown } {
  return data !== null && typeof data === 'object' && 'data' in data && data.data !== undefined;
}

function validateResponsePayload<TResponse>(
  validator: (data: unknown) => data is TResponse,
  data: unknown
): TResponse | void {
  if (validator(data)) {
    return data;
  }

  return void 0;
}
